import React from 'react';

import Link from 'gatsby-link';

import map from 'lodash/map';

import { withStyles } from '@material-ui/core/styles';

import Paper from '../Paper';
import Title from '../Title';

const styles = () => ({
  container: {
    display: 'block',
    textDecoration: 'none',
  },
  category: {
    color: '#2b2a29',
    fontSize: 14,
    fontFamily: 'Raleway',
    lineHeight: 1.91,
  },
});

const Categories = ({ classes, nodes }) => {
  return (
    <Paper>
      <Title>Categories</Title>
      {map(nodes, ({ node: { id, name, slug, count } }) => (
        <Link
          key={id}
          to={`/blog/category/${slug}`}
          className={classes.container}
        >
          <div className={classes.category}>{`${name} (${count})`}</div>
        </Link>
      ))}
    </Paper>
  );
};

export default withStyles(styles)(Categories);
